module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-6dcbf393.svg";